import WebhookStreamSettings from '@/modules/integrations/types/webhookstream/WebhookStreamSettings'

export default Object.freeze({
  type: 'webhookstream',
  title: 'Integrations_WebhookStream',
  category: 'Integrations_Webhook_Category',
  description: 'Integrations_Webhook_Stream_Description',
  image: require('@/img/integrations/webhook.png'),
  requiresApproval: false,
  components: {
    settings: WebhookStreamSettings
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/webhooks-integration'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/webhookstream/index.js